export class HouseOwnerContactData {
    id: number;
    active_contact: boolean;
    email: string;
    first_name: string;
    second_name: string;
    short_name: string;
    telephone_number: string;
}